// extracted by mini-css-extract-plugin
export var collapsedSummary = "_os-0";